import React from 'react';

export default class HELearnerRegistration extends React.Component {
  render() {
    return null;
  }
}
